module.exports = __webpack_public_path__ + "media/images/default/pages/homepage/questions/1-15c33ee472610ca14bea539a1913d589.svg";